module.exports = __webpack_public_path__ + "img/double-checkmark.5b3d2dd8.svg";